import axiosInstance from '../../../utils/api/axiosInstance';
import { LiveActivitiesResponse } from '../interface/LiveActivities.interface';
import { MyTeamsInterface, RunningActivitiesResponse } from '../interface/RunningActivities.interface';

export const getStatistics = async (): Promise<any> => {
	return (await axiosInstance.get('home/statistics')).data;
};

export const getActivities = async (liveActivityNo: number): Promise<LiveActivitiesResponse[]> => {
	return (await axiosInstance.get('activities/playing-time', { params: { page: liveActivityNo } })).data;
};

export const getRuiningActivities = async (): Promise<RunningActivitiesResponse[]> => {
	return (await axiosInstance.get('activities/running')).data.activities;
};
export const getMyTeams = async (): Promise<MyTeamsInterface[]> => {
	return ((await axiosInstance.get('home/tournaments/my-teams')).data.records);
}

export const getMasterStanding = async (page: number) => {
	return (await axiosInstance.get('home-standing', { params: { page: page } })).data;
};

